module.exports = __webpack_public_path__ + "img/icon_monitor_size_8_hl.7e79da7b.webp";